import { getRegisterFunction } from '../../utils/register.js';
import { OneUxLinkElement } from './OneUxLinkElement.js';
export const register = getRegisterFunction(OneUxLinkElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-link': OneUxLinkElement;
    "link-ba1a097dce60a443bc678c9ed9cb57a9": OneUxLinkElement;
  }
}